import { WalletPass } from "./WalletPass";

function StatusBar() {
  return (
    <div className="relative z-20 h-[46px] flex items-center justify-between px-7 text-white text-[13px] font-semibold">
      <span className="tracking-tight">9:41</span>
      <span className="flex items-center gap-1.5">
        <svg width="17" height="11" viewBox="0 0 17 11" fill="none"><rect y="7" width="3" height="4" rx="1" fill="#fff" /><rect x="4.5" y="5" width="3" height="6" rx="1" fill="#fff" /><rect x="9" y="2.6" width="3" height="8.4" rx="1" fill="#fff" /><rect x="13.5" width="3" height="11" rx="1" fill="#fff" /></svg>
        <svg width="16" height="11" viewBox="0 0 15 11" fill="none"><path d="M7.5 2.2c2 0 3.9.8 5.3 2.1l1.1-1.2A9.4 9.4 0 0 0 7.5.5 9.4 9.4 0 0 0 1.1 3.1l1.1 1.2A7.4 7.4 0 0 1 7.5 2.2Z" fill="#fff" /><path d="M7.5 5.4c1.1 0 2.2.4 3 1.2l1.1-1.2a6 6 0 0 0-8.2 0L4.5 6.6a4.3 4.3 0 0 1 3-1.2Z" fill="#fff" /><circle cx="7.5" cy="9" r="1.6" fill="#fff" /></svg>
        <svg width="27" height="13" viewBox="0 0 27 13" fill="none"><rect x="0.6" y="0.6" width="22" height="11.8" rx="3.2" stroke="#fff" strokeOpacity="0.5" /><rect x="2.2" y="2.2" width="18" height="8.6" rx="1.8" fill="#fff" /><rect x="24" y="4.2" width="2" height="4.5" rx="1" fill="#fff" opacity="0.5" /></svg>
      </span>
    </div>
  );
}

// Premium iPhone mockup. Pass `screen` for full custom screen (e.g. lock screen),
// otherwise renders the wallet screen with a pass.
export function PhoneMock({ children, program, wallet = "apple", state = {}, width = 300, label = "Wallet", screen, className = "" }) {
  const inner = children || <WalletPass program={program} wallet={wallet} state={state} />;
  return (
    <div style={{ width }} className={`relative ${className}`}>
      <div className="absolute left-[-3px] top-[112px] w-[3px] h-8 rounded-l bg-[#26272b]" />
      <div className="absolute left-[-3px] top-[158px] w-[3px] h-14 rounded-l bg-[#26272b]" />
      <div className="absolute left-[-3px] top-[224px] w-[3px] h-14 rounded-l bg-[#26272b]" />
      <div className="absolute right-[-3px] top-[178px] w-[3px] h-20 rounded-r bg-[#26272b]" />
      <div className="rounded-[54px] bg-gradient-to-b from-[#1a1a1c] to-[#050505] p-[12px] shadow-[0_60px_100px_-32px_rgba(11,13,16,0.65)]">
        <div className="rounded-[44px] p-[3px] bg-black">
          <div className="relative rounded-[41px] overflow-hidden" style={{ aspectRatio: "9 / 19.3", background: screen ? undefined : "radial-gradient(120% 80% at 50% 0%, #232427 0%, #0a0a0b 60%, #000 100%)" }}>
            {/* dynamic island */}
            <div className="absolute top-[13px] left-1/2 -translate-x-1/2 h-[25px] w-[64px] rounded-full bg-black z-40 flex items-center justify-end pr-2.5">
              <div className="h-[7px] w-[7px] rounded-full bg-[#101012] ring-1 ring-[#26262a]" />
            </div>
            <StatusBar />
            <div className="absolute inset-0 z-10 pointer-events-none" style={{ background: "linear-gradient(135deg, rgba(255,255,255,0.05) 0%, transparent 32%)" }} />
            {screen ? (
              <div className="relative z-20 h-[calc(100%-46px)]">{screen}</div>
            ) : (
              <div className="relative z-20 px-4 pt-3 pb-8">
                <div className="text-white/45 text-[13px] font-medium mb-3 px-1">{label}</div>
                <div className="flex justify-center"><div className="scale-[0.78] origin-top">{inner}</div></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
